module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("INTERSECTIONS")]), _c('br'), _vm._v("Transdisciplinary Perspectives on Genders and Sexualities"), _c('br'), _vm._v("General Editors: Michael Kimmel and Suzanna Walters")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Sperm Counts: Overcome by Man’s Most Precious Fluid")]), _c('br'), _vm._v("Lisa Jean Moore")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Sexuality of Migration:"), _c('br'), _vm._v("Border Crossings and Mexican Immigrant Men")]), _c('br'), _vm._v("Lionel Cantú, Jr."), _c('br'), _vm._v("Edited by Nancy A. Naples and Salvador Vidal-Ortiz")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Moral Panics, Sex Panics:"), _c('br'), _vm._v("Fear and the Fight over Sexual Rights")]), _c('br'), _vm._v("Edited by Gilbert Herdt")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Out in the Country:"), _c('br'), _vm._v("Youth, Media, and Queer Visibility in Rural America")]), _c('br'), _vm._v("Mary L. Gray")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Sapphistries: A Global History of Love between Women")]), _c('br'), _vm._v("Leila J. Rupp")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Strip Club: Gender, Power, and Sex Work")]), _c('br'), _vm._v("Kim Price-Glynn")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Sexualities for Life: From Adolescence to the Golden Years, How Sex Changes throughout Our Lives")]), _c('br'), _vm._v("Edited by Laura M. Carpenter and John DeLamater")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Bully Society:"), _c('br'), _vm._v("Shootings, Gender, and Related Violence in American Schools")]), _c('br'), _vm._v("Jessie Klein")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("One Marriage under God:"), _c('br'), _vm._v("The Campaign to Promote Marriage in America")]), _c('br'), _vm._v("Melanie Heath")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3204dc75","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02.vue
// module id = 63
// module chunks = 0